export interface FaqItem {
	question: string;
	answer: string;
}

/**
 * Answers lead with a direct response so they can be quoted standalone — by a
 * search snippet, an AI answer engine, or the FAQPage schema built from this
 * same array.
 */
export const faqItems: FaqItem[] = [
	{
		question: "How is Ploy different from Vercel or Netlify?",
		answer:
			"Ploy is an open-source serverless cloud with the whole stack included: databases, queues, cron, durable workflows, state, file storage, sandboxes, auth, and model access ship with every project, and you can self-host the entire platform for free. Vercel and Netlify focus on hosting request/response frontends on proprietary platforms, with the backend left to add-ons. That difference matters most for apps with real backends and for agents, which run long, call tools, hold state, and fail halfway through: Ploy's durable workflows outlive a single request and retry failed steps, sandboxes execute code an agent wrote, and each project gets its own SQLite database.",
	},
	{
		question: "What can I deploy on Ploy?",
		answer:
			"Next.js, Vite, and TanStack Start apps, static sites, and plain serverless workers written in TypeScript. A ploy.yaml in the repository describes the build and the resources the project needs, and every push builds and deploys it: the production branch goes live, every other branch gets its own preview URL.",
	},
	{
		question: "Do I need a GitHub account?",
		answer:
			"No. Connect a GitHub repository, or create a Ploy Git repository hosted by Ploy and push to it with any git client from a laptop, a CI job, or an AI agent. Both sources get production and preview deployments, and you can move a project between them with its history intact.",
	},
	{
		question: "Can an agent run longer than a normal serverless function?",
		answer:
			"Yes. Long runs belong in a workflow rather than a request handler. A workflow is made of steps, and each step is durably persisted as it completes. If a step throws, only that step retries — three times with exponential backoff by default, configurable per workflow — and the work before it is not repeated. Every step of a run is inspectable in the dashboard.",
	},
	{
		question: "Is it safe to execute code my agent generated?",
		answer:
			"Run it in a sandbox. Sandboxes are isolated, long-lived environments with their own filesystem, where your worker can run shell commands, clone repositories, and stream output. Each sandbox is addressed by id, so you can keep one alive across requests for a single agent session or start a fresh one per task.",
	},
	{
		question: "Which models can I call from a Ploy agent?",
		answer:
			"Add ai: true to your ploy.yaml and your worker receives an env.AI binding, which you call with env.AI.run(model, inputs). The binding is OpenAI-compatible, so an existing SDK works too — point it at the base URL and token that Ploy injects. Those credentials are managed per deployment, so your agents never carry their own provider keys.",
	},
	{
		question: "Can we run Ploy inside our own infrastructure?",
		answer:
			"Yes. Ploy is open source and self-hostable on bare metal, AWS, GCP, Azure, or anywhere you run containers. Prompts, traces, and agent state stay in your own database, which matters when data residency or procurement rules out a managed vendor. The managed cloud runs the same code, so moving between them is not a rewrite.",
	},
	{
		question: "How much does Ploy cost?",
		answer:
			"Self-hosting is free and open source forever. The managed cloud has a free tier for prototypes and side projects including unlimited preview deployments, a Pro plan at $10 per month for production agents with custom domains, higher concurrency, and 90-day retention, and an Enterprise plan with dedicated infrastructure, SLAs, and volume pricing.",
	},
];
